
export default {
	name: '帐篷3',
	// 产品参数
	overview: {
		// 详细信息
		details: [
			{ label: "灯管发光效率（lm/w）", value : "207"},
			{ label: "显色指数(Ra) ", value : "80"},
			{ label: "支持调光器", value : "是的"},
			{ label: "照明解决方案服务", value : "照明和电路设计、DIALux evo 布局、LitePro DLX 布局、Agi32 布局、自动 CAD 布局、现场测光"},
			{ label: "寿命（小时）", value : "30000"},
			{ label: "工作时间（小时）", value : "30000"},
			{ label: "产品重量（kg）", value : "0.43"},
			{ label: "应用", value : "种子开始，BLOOM，其他，VEG"},
			{ label: "PPFDμmol/(m2·s) ", value : "250-350"},
			{ label: "输入电压（V）", value : "110-240V"},
			{ label: "工作温度（℃）", value : "-20 - 60"},
			{ label: "工作寿命（小时）", value : "30000"},
			{ label: "灯体材质", value : "铝"},
			{ label: "知识产权等级", value : "IP65"},
			{ label: "产地", value : "Guangdong, China"},
			{ label: "品牌名称", value : "IGS-31"},
			{ label: "瓦数", value : "10W"},
			{ label: "光源", value : "引领"},
			{ label: "保修期（年）", value : "1年"},
			{ label: "产品类型", value : "芯片LED生长灯"},
			{ label: "型号", value : "IGS-31"},
			{ label: "芯片组", value : "贴片2835"},
			{ label: "LED灯", value : "特殊光谱"},
			{ label: "材料", value : "涂漆金属"},
			{ label: "寿命", value : "30000 小时"},
			{ label: "产品尺寸", value : "3710X130X100mm"},
			{ label: "特殊功能", value : "照明/时间模式开关"},
			{ label: "保修", value : "1年"},
			{ label: "证书", value : "ce、ETL、FCC、RoHS"},
			{ label: "供应能力", value : "每周 50000 包/包"},
		],
		// 包装
		packaging: [
			{ label: "包装细节", value : "中性包装彩盒。"},
			{ label: "港口", value : "Shenzhen"},
			{ label: "交货时间", value : "<b>1-100:</b>3天<br/>	<b>101-500:</b>5天<br/>	<b>501-1000:</b>7天<br/>	<b>>1000:</b>待协商"},
		],
	},
	// 视频
	videos: {
		// 介绍
		introduction: [
			{ label: "DJI Pocket 2 | 介绍视频", date: "2020-07-08", cover: "https://www1.djicdn.com/cms/uploads/bbb15726362623442902bebca757bb55@770*462.jpg", src: "https://cdn.djivideos.com/watch/89673044-e8ba-4fa3-a58a-a9ce23087467?autoplay=false&poster=https://videocaption.djicdn.com/poster/20201019/d16a55cc894d7ff2c8a84f05734b8bee.png@!1200"},
			{ label: "DJI Pocket 3 | 介绍视频", date: "2020-07-08", cover: "https://www1.djicdn.com/cms/uploads/bbb15726362623442902bebca757bb55@770*462.jpg", src: "https://cdn.djivideos.com/watch/89673044-e8ba-4fa3-a58a-a9ce23087467?autoplay=false&poster=https://videocaption.djicdn.com/poster/20201019/d16a55cc894d7ff2c8a84f05734b8bee.png@!1200"}
		],
		// 教程
		course: [
			{ label: "IGS11 视频介绍", date: "2020-10-20", cover: "https://sc01.alicdn.com/kf/H39eb36fabba14cd1a0d6d9d338a0b712f.jpg", src: "//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/288872778138.mp4"}
		],
	}
}
